import React from 'react';
import {
  bonfire,
  rocket,
  football,
  library,
  person,
  extensionPuzzle,
  school,
} from 'ionicons/icons';
import './LegacyProfile.css';
import { useHistory } from 'react-router';
import WholeMeProfileQuotationTemplate from '../wholeMeProfileQuotation/WholeMeProfileQuotationTemplate';

const LegacyProfile = ({
  legacyProfileData: userPublicData, onEdit, isViewOnly,
}) => {
  const history = useHistory();
  const possiblePublicInfo = {
    pronouns: {
      icon: person,
    },
    school: {
      icon: library,
    },
    school_type: {
      icon: school,
    },
    user_bio: {
      icon: null,
    },
    activities: {
      icon: football,
    },
    passions: {
      icon: bonfire,
    },
    aspirations: {
      icon: rocket,
    },
    activations: {
      icon: extensionPuzzle,
    },
  };
  const handleEdit = (type = 'additional') => {
    if (!onEdit) {
      return undefined;
    }
    return history.push(`/tabs/profile/edit-${type}-info`);
  };
  return (
    <>
      {Object.keys(possiblePublicInfo).map((info) => {
        if (info === 'school') {
          return (
            userPublicData?.[info] && (
              <WholeMeProfileQuotationTemplate
                key={info}
                label={`${userPublicData?.[info]}`}
                editHandler={() => handleEdit('profile')}
                isViewOnly={isViewOnly}
              />
            )
          );
        }
        if (info === 'school_type') {
          return (
            userPublicData?.[info] && (
              <WholeMeProfileQuotationTemplate
                key={info}
                label={`${userPublicData?.[info]}`}
                editHandler={() => handleEdit('profile')}
                isViewOnly={isViewOnly}
              />
            )
          );
        }
        if (info === 'user_bio') {
          return (
            userPublicData?.[info] && (
              <WholeMeProfileQuotationTemplate
                key={info}
                label={`${userPublicData?.[info]}`}
                editHandler={() => handleEdit()}
                isViewOnly={isViewOnly}
              />
            )
          );
        }
        return (
          userPublicData?.[info] && (
            <WholeMeProfileQuotationTemplate
              key={info}
              label={`${userPublicData?.[info]}`}
              editHandler={() => handleEdit()}
              isViewOnly={isViewOnly}
            />
          )
        );
      })}
    </>
  );
};

export default LegacyProfile;
